/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'approversEntityArea';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'globalEntityApproverByArea';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'approverEntityArea';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'approversEntityArea';

/** Default list sort — matches legacy `useManageApproverEntityArea`. */
export const DEFAULT_ORDER_BY = 'dynamicEntity/displayName asc';
